var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bmxx"},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"调动记录","name":"distributiont"}})],1),(_vm.activeName==='distributiont')?_c('distributiont'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }